import Config from '@app/dev/config/main';
import { POPUPS } from '@common/constants/popups';

const signInTypesEnum = {
  cpf: {
    popupType: POPUPS.SIGN_IN,
    type: 'cpf',
  },
  email: {
    popupType: POPUPS.LOGIN_FORM,
    popupParams: { signInToAdmin: false, popupPosition: 'top' },
    type: 'email',
  },
};

export const signInType = signInTypesEnum[Config.main.signInType]?.type;
export const signInParams = signInTypesEnum[Config.main.signInType]?.popupParams;
export const signInPopupType = signInTypesEnum[Config.main.signInType]?.popupType;
